import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import HeadOfficeTab_3 from "examples/Tabs/HeadOfficeTab_3";

function HeadOffice_3() {
  return (
    <DashboardLayout>
      <HeadOfficeTab_3 />
    </DashboardLayout>
  );
}

export default HeadOffice_3;
